import React from "react";
import "./style.scss";

export default function BasicTextArea({
  placeholder = "",
  disabled = false,
  value = "",
  onChange = () => {},
  className = "",
  sx = {},
  required = false
}) {
  return (
    <div
      className={`input-wrapper ${disabled ? "disabled" : ""} ${className}`}
      style={{ ...sx }}
    >
      <textarea
        placeholder={placeholder}
        disabled={disabled}
        value={value}
        required = {required}
        onChange={onChange}
        className="input-box"
      />
    </div>
  );
}
